import Preact, { h, Component } from 'preact'
import Icon from '../assets'
import UserAvatar from '../User/UserAvatar'
import Dropdown from '../dropdown'
import axios from "axios"
import { common } from '../common'
import BetaBadge from '../ui-components/BetaBadge'
import globals, {publish} from '../../utils/globals'

type Link = {
  label: string,
  route: string,
  isBeta: boolean
}

type Name = string

type User = {
  id: number,
  name: string,
  avatar: string
}

type CustomView = {
  id: number,
  name: string,
  type: string
}

type SidebarItem = {
  name: Name,
  label: string,
  links: { [index: string ] : any },
  iconName: any
}

interface Props {
  sidebar: SidebarItem[],
  customFilters: Link[],
  privateMessagesUnreadCount: number,
  customerName: string,
  user: User
}

interface State {
  activeItemName: Name | null,
  isOpen: boolean,
  isOverlay: boolean,
  customViews: [],
  spamCount: number | null,
  pendingCount: number | null
}

const ITEMS_WITH_NO_SUBMENU = ['privateMessages', 'openCommunity', 'team']

class ControlSideMenu extends Component<Props, State> {
  private arrowElement: HTMLInputElement | null = null
  private subMenuElement: HTMLInputElement | null = null
  private mainContainerElement: HTMLElement | null = null
  private timer: number | undefined

  constructor ({ sidebar, customFilters }: Props) {
    super()

    this.state = {
      activeItemName: null,
      isOpen: true,
      isOverlay: false,
      customViews: [],
      spamCount: null,
      pendingCount: null
    }
    this.setActiveItem(sidebar, customFilters)

    this.arrowElement = Preact.createRef()
    this.subMenuElement = Preact.createRef()
  }

  async componentDidMount() {
    await this.fetchModerationOverviewViews()

    const { sidebar, customFilters } = this.props
    this.setActiveItem(sidebar, customFilters)

    const {isOpen, activeItemName } = this.state
    this.mainContainerElement = document.querySelector('.main-control-side-menu') || document.querySelector('.control-side-menu-content')

    if(!isOpen || activeItemName === null) {
      this.mainContainerElement!.style.marginLeft = this.isProfilePage() || this.isProfileFieldPage() ? '40px' : '0';
    }

    await this.setSpamCount()
    await this.setPendingCount()
    window.addEventListener('hashchange', () => this.forceUpdate())

    publish('control_sidebar_state', { isOpen })

    // this is fired when approving pending posts and marking posts and not spam from legacy code
    window.addEventListener('updateMenuCounts', async () => {
      await this.setSpamCount()
      await this.setPendingCount()
    })
  }

  setSpamCount = async () => {
    try {
      const { data } = await axios.get('/spam/spamPostsCount')
      this.setState({ spamCount: data.count })
    } catch (e) {}
  }

  setPendingCount = async () => {
    try {
      const { data } = await axios.get('/moderation/countPendingPosts')
      this.setState({ pendingCount: data.count })
    } catch (e) {}
  }

  setActiveItem (sidebar: SidebarItem[], customFilters: Link[]) {
    const { customViews } = this.state

    sidebar.map((item: SidebarItem) => {
      if (isItemActive(item, customFilters, customViews)) {
        const isOpenSubmenu = !ITEMS_WITH_NO_SUBMENU.includes(item.name)
        this.setState({
          activeItemName: item.name,
          isOpen: isOpenSubmenu
        })
      }
    })
  }

  toggleMenuItem (event: any, item: SidebarItem) {
    if (item.label.toLowerCase() === 'content') {
      this.setSpamCount()
      this.setPendingCount()
    }
    event && event.preventDefault()
    this.setState({
      activeItemName: item.name,
      isOpen: true
    }, () => this.openSidebar())
  }

  onArrowHoverLeave () {
    const { isOpen } = this.state
    const isSubMenuHover = this.subMenuElement && this.subMenuElement.matches(':hover')

    if (isOpen || !isSubMenuHover) {
      return
    }

    this.setState({ isOverlay: true })
  }

  onSubmenuHover () {
    const { isOpen } = this.state
    const isArrowHover = this.arrowElement && this.arrowElement.matches(':hover')

    if (isOpen || isArrowHover) {
      return
    }

    this.timer = window.setTimeout(() => {
      this.setState({ isOverlay: true })
    }, 500)
  }

  isTopicOverview = () => this.mainContainerElement?.getAttribute('id') ==='content'

  isProfilePage = () => window.location.pathname.includes('member/profile')

  isProfileFieldPage = () => window.location.pathname.includes('settings/profilefield')

  openSidebar() {
    this.mainContainerElement!.style.marginLeft = this.state.isOverlay ? this.isTopicOverview() ? '40px': '16px' : this.isTopicOverview() ? '280px' : '240px'

    publish('control_sidebar_state', { isOpen: true })
  }

  closeSidebar() {
    this.mainContainerElement!.style.marginLeft = this.isTopicOverview() ? '40px': '16px'

    publish('control_sidebar_state', { isOpen: false })
  }

  async fetchModerationOverviewViews () {
    await axios.get('/views')
        .then(res => this.setViews(res.data))
        .catch(e => {
          if (e.response.status !== 403) throw e
        })
  }

  setViews (views: CustomView[]) {
    const menuItems = views.map(view => ({
        label: view.name,
        route: `${view.type === 'default' ? '' : `/${view.type}`}/overview/${view.id}`
      })
    )

    this.setState({ customViews: menuItems as any })
  }

  render
  ({ sidebar, customFilters, privateMessagesUnreadCount, customerName, user }: Props,
   { activeItemName, customViews, isOpen, isOverlay, spamCount, pendingCount }: State)
  {
    return (
      <div class='control-side-menu-wrapper'>
          <div class='control-side-menu'>
              <div className='control-side-menu__menu-item-logo'>
                <img src={`${globals('basePath')}images/logo-inverse.png`} />
                <div className='control-side-menu__menu-item-label'><span>Proudly working for {customerName} 💙</span></div>
              </div>
              {sidebar.map((item: SidebarItem) => {
                const isActive = isItemActive(item, customFilters, customViews)
                const isFirstItemOfSecondaryList = item.name === 'openCommunity'
                return ITEMS_WITH_NO_SUBMENU.includes(item.name) ?
                    item.name === 'privateMessages' ?
                      <a href={item.links[0].route}>
                        <MenuItem isActive={isActive} item={item}>
                          { privateMessagesUnreadCount > 0 ?
                              <div class='control-side-menu__menu-item--pm-count'>
                                {privateMessagesUnreadCount < 100 ? privateMessagesUnreadCount : <span class='morePms'>•••</span>}
                              </div> : undefined }
                        </MenuItem>
                      </a>
                    : <a class={`${isFirstItemOfSecondaryList ? 'push-up': ''}`} href={item.links[0].route} target={item.name === 'openCommunity' ? '__blank': undefined}>
                      <MenuItem isActive={isActive} item={item} />
                    </a>
                : <MenuItem isActive={isActive} item={item} onClick={(event: any) => this.toggleMenuItem(event, item)} />
              })
              }
            <div class='control-side-menu__menu-item-avatar'>
              <Dropdown class='' trigger={<UserAvatar user={{ ...user }} disableLink />}>
                <div class='control-side-menu__menu-user'>
                  <a href='/member/logout'><Icon icon='logOut' />Log out</a>
                </div>
              </Dropdown>
            </div>
          </div>
        <div
          class={`control-side-menu__details${!isOpen ? ' collapsed' : ''}${isOverlay ? ' overlay' : ''}`}
          ref={subMenu => { this.subMenuElement = subMenu }}
          onMouseEnter={() => this.onSubmenuHover()}
          onMouseLeave={() => {
            if(this.timer) window.clearTimeout(this.timer)
            !isOpen && this.setState({ isOverlay: false }, () => this.closeSidebar())
          }}
          style={{'display': activeItemName && !ITEMS_WITH_NO_SUBMENU.includes(activeItemName) ? 'flex' : 'none'}}
        >
          {sidebar.map((item: SidebarItem) => {
            if (activeItemName === item.name) {
              const wrapperProps: { [prop: string]: any } = {
                class: 'control-side-menu__items-wrapper'
              }
              if(!isOpen && !isOverlay) wrapperProps.style = { 'visibility': 'hidden'}

              return <div {...wrapperProps} >
                <div class='control-side-menu__details-heading'>{item.label}</div>
                { !Array.isArray(item.links) ?
                    <div>
                      <GroupedItemList item={item} spamCount={spamCount} pendingCount={pendingCount} />
                      { item.name === 'moderation' && (customFilters.length > 0 || customViews.length > 0) && <CustomFiltersList customFilters={customFilters} customViews={customViews} /> }
                    </div>
                  : <ItemList item={item} />
                }
              </div>
            }
            return null
          })
          }
          <div
            class='control-side-menu__details-arrow'
            ref={arrow => { this.arrowElement = arrow }}
            onClick={() => this.setState({ isOpen: !isOpen, isOverlay: false }, () => isOpen ? this.closeSidebar() : this.openSidebar())}
            onMouseLeave={() => this.onArrowHoverLeave()}
          >
            <Icon icon='arrowRoundedLeft' />
          </div>
        </div>
      </div>
    )
  }
}

export default ControlSideMenu

const isItemActive = (item: SidebarItem, customFilters: Link[], customViews: Link[]) => {
  if(Array.isArray(item.links)) {
    return item.links.some(isActiveLink)
  }

  const subLinks = Object.keys(item.links)
      .map((groupName: string) => item.links[groupName])
      // flat the array
      .reduce((acc, val) => acc.concat(val), [])

  return subLinks.some(isActiveLink)
      || (item.name === 'moderation' && customFilters && customFilters.some(isActiveLink))
      || (item.name === 'moderation' && customViews && customViews.some(isActiveLink))
}

const isActiveLink = (link: Link) => {
  const index = link.route.indexOf('#')
  const search = normalizeSearch()

  if (index > 0) {
    return window.location.pathname + search + window.location.hash === link.route
  }

  return window.location.pathname + search === link.route
}

const normalizeSearch = () => {
  const search = window.location.search
  if (!search) {
    return ''
  }

  const queriesToExclude = ['page', 'showMessage', 'view', 'date_range', 'date_from', 'date_till', 'roles', 'ranks', 'categories', 'content_types']
  let searchQueries = search.split('?').join('').split('&')

  searchQueries = searchQueries.filter((query: string) => {
    let keepQuery = true

    queriesToExclude.forEach((queryToExclude: string) => {
      if (query.startsWith(queryToExclude)) {
        keepQuery = false
      }
    })

    return keepQuery
  })

  if (searchQueries.length === 0) {
    return ''
  }

  return '?' + searchQueries.join('&')
}

const renderLink = ({isCustomFilter, isDeprecated = false, spamCount = null, pendingCount = null}: {isCustomFilter: boolean, isDeprecated?: boolean, spamCount?: number | null,  pendingCount?: number | null}) => {
  return (link: Link) => {
    const isActive = isActiveLink(link)
    const isSpam = link.label.toLowerCase() === 'spam'
    const isPending = link.label.toLowerCase() === 'pending'

    return <li
      class={'navigation-menu__item--' + link.label.toLowerCase().replace(/ /g, '_') + (isCustomFilter ? ' custom qa-custom' : '')}>
      <a class={isActive ? 'active' : undefined} href={link.route}>{link.label}
      {isDeprecated ? <Icon customClass='icon-warning' color='#9599A2' icon='warning' width={20} height={20} />:''}
      {link.isBeta && <BetaBadge />}
        { (isSpam && spamCount !== null ) && <span>({spamCount})</span> }
        { (isPending && pendingCount !== null) && <span>({pendingCount})</span> }
      </a>
    </li>
  }
}

const ItemList = ({ item } : { item: SidebarItem }) => {
  return <ul>{item.links.map(renderLink({isCustomFilter: false}))}</ul>
}

const GroupedItemList = ({ item, spamCount = null, pendingCount = null } : { item: SidebarItem, spamCount?: number | null,  pendingCount?: number | null }) => {
  return <div>{Object.keys(item.links).map((groupName: string) => {
    const subLinks = item.links[groupName]
    return <div>
      <div class='control-side-menu__details-sub-heading'>{groupName}</div>
      <ul>
        {subLinks.map(renderLink({isCustomFilter: false, spamCount, pendingCount }))}
      </ul>
    </div>
  })}</div>
}

const CustomFiltersList = ({customFilters, customViews}: {customFilters: Link[], customViews: Link[]}) => {
  if (common.isModuleActive('moderationOverviewBetaDefault')) {
    return <div>
      <div className='control-side-menu__details-sub-heading'>custom views</div>
      <ul>
        {customViews.length > 0 && customViews.map(renderLink({isCustomFilter: true}))}
        {customFilters.length > 0 && customFilters.map(renderLink({isCustomFilter: true, isDeprecated: true}))}
      </ul>
    </div>
  }
  return <div>
    {customViews.length > 0
        ? <div>
          <div className='control-side-menu__details-sub-heading'>custom views</div>
          <ul>{customViews.map(renderLink({isCustomFilter: true}))}</ul>
        </div>
        : null}
    {customFilters.length > 0
        ? <div>
          <div className='control-side-menu__details-sub-heading'>custom filters</div>
          <ul>{customFilters.map(renderLink({isCustomFilter: true}))}</ul>
        </div>
        : null }
  </div >
}

const MenuItem = ({ item, isActive, onClick, children }: { item: { label: string, iconName: any }, isActive: boolean, onClick?: (event: any) => void, children?: JSX.Element }) => {
  const props = {
    class: `control-side-menu__menu-item${isActive ? ' active' : ''}`,
    onClick: onClick
  }

  return <div {...props}>
    <Icon icon={item.iconName} width={20} height={20} color={isActive ? ' #FFFFFF' : '#D5D6D6'}/>
    <div className='control-side-menu__menu-item-label'><span>{item.label}</span></div>
    {children}
  </div>
}
